import { Navigate } from "react-router-dom";
import useBusiness from "@/core/business/use-business";
import { ONBOARDING_STEP } from "@/onboarding/constants";
import PostOnboardingItems from "./post-onboarding/post-onboarding-items";
import WaitingPageLayout from "./waiting-page-layout";

const WaitingForSetup = () => {
  const { selectedBusiness } = useBusiness();

  const isOnboardingComplete =
    selectedBusiness &&
    selectedBusiness.onboarding_step === ONBOARDING_STEP.completed;

  if (isOnboardingComplete) {
    return <Navigate to="/" />;
  }

  return (
    <WaitingPageLayout
      headline="Working on setting up the platform for you"
      body="An admin, owner, or manager is completing the onboarding process. Once setup is complete, you'll have access to all the features of the platform. Hang tight!"
    >
      <PostOnboardingItems />
    </WaitingPageLayout>
  );
};

export default WaitingForSetup;
